module.exports = "<app-admin-header></app-admin-header>\n  <ng-content></ng-content>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/admin-standard-template/admin-standard-template.component.html
// module id = ../../../../../src/app/admin-standard-template/admin-standard-template.component.html
// module chunks = main